import 'classlist.js';  // Run `npm install --save classlist.js`.
import 'core-js/es/reflect';
import 'web-animations-js';  // Run `npm install --save web-animations-js`.
import 'zone.js/dist/zone';  // Included with Angular CLI.
